/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  $('body').on('click', '.variant-modal .radio__button, .selector-wrapper .radio__button', (e)=>{    
    $('[name="add"]').removeAttr("not-selected")
  })
  // Add custom code below this line  
  if($(window).width() < 480){
    document.addEventListener("isInViewport", (e) => {
      $('#cart-bar').toggleClass("is-visible", e.detail);
    });
    $('.variant-modal .radio__button').on('click', (e)=>{	
        let event = new CustomEvent("variantSelected");
        document.addEventListener("newVariant", () => {          
          document.dispatchEvent(event);
        });        
        $('.variant-modal, .drawer__overlay').toggleClass('hidden');
        $('body').css('overflow', 'auto');  
    })
    $('[name="add"], .cart-bar__submit button').on('click', (e)=>{
      if(document.querySelector('[name="add"]').hasAttribute("not-selected")){
        $('.variant-modal, .drawer__overlay').toggleClass('hidden');
        $('#cart-bar').removeClass('is-visible');  
        $('body').css('overflow', 'hidden');        
      }else {
        let event = new CustomEvent("variantSelected");         
        document.dispatchEvent(event);
      }
    })
  
    $('.cart-modal-close').on('click', ()=>{    
          $('.variant-modal, .drawer__overlay').toggleClass('hidden');
          $('body').css('overflow', 'auto');     
    })
  }

    
    $('.radio__button.sale').on('click', (e)=>{
      $('[name="add"]').removeAttr("not-selected");
    })
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
